/* =========================================================================
   Paws by Ciroa, gift set contents.

   A set's description is a line by line list of what is in the box. This turns
   each line into the real catalogue product so the page can show its photo, a
   line on why it is in the box, a one line how to use it, a quick look, and a
   link through.

   EACH PIECE GETS ITS OWN SPOTLIGHT. The card shows the product callout, the
   approved one liner on what that product is for, and the first sentence of
   its directions. Full directions stay behind the button. A box of five
   bottles with no explanation is a list, not a gift.

   HOW A LINE IS MATCHED

   Stage one, ALIASES. Explicit pack phrase to catalogue product name. The pack
   and the catalogue do not always agree: the pack says "Odour control spray",
   the catalogue says "Deodorising spray". Fuzzy rules could be loosened to
   catch those, but every loosening also invented wrong matches, so anything
   irregular goes here instead. Adding a line takes a minute and cannot misfire.

   Stage two, fuzzy match, deliberately strict in BOTH directions:
     1. The line must contain a known product type stem.
     2. If the line names a range, only that range is considered.
     3. The product must not carry a distinguishing word the line lacks.
     4. The line must not carry a distinguishing word the product lacks. This
        is what stops "Treat Holder" matching "Poo bag holder".
     5. One candidate left is the match, otherwise narrow by size, then by the
        whole name appearing in the line.
     6. No confident match means a slim card with the pack wording. Nothing is
        ever dropped, it just appears without a photo.

   Anything containing a digit is never treated as a distinguishing word. "500ml"
   written without a space was being read as one, which knocked out the Fresh
   Fur Baby shampoo and conditioner on BYE BYE STINK.

   NOTE ON REGEXES. No backslash escapes in here, on purpose. Sequences like
   \\d and \\s do not survive into a theme file and have silently broken three
   things on this build: quiz emoji, the breed tag, and trailing commas.
   ========================================================================= */
(function () {
  'use strict';

  /* Every stem in needs[] must appear in the line. name is the catalogue
     display name, so there are no handles to keep in sync. */
  var ALIASES = [
    { needs: ['detangl'],              name: 'Pre-grooming detangler' },
    { needs: ['finger', 'ear'],        name: 'Ear cleanser finger wipes' },
    { needs: ['finger', 'dental'],     name: 'Dental cleanser finger wipes' },
    { needs: ['odour', 'spray'],       name: 'Deodorising spray' },
    { needs: ['poo', 'roll'],          name: 'Scented poo bags' },
    { needs: ['treat'],                name: 'Treat bag' },
    { needs: ['wash', 'brush'],        name: 'Shampoo brush' },
    { needs: ['navy', 'brush'],        name: 'Shampoo brush' },
    { needs: ['30', 'wipes'],          name: 'Wet wipe gloves' },
    { needs: ['pack', '80', 'wipes'],  name: 'Scented wet wipes' }
  ];

  var RANGES = ['coat care', 'calm paws', 'soothe me', 'fresh fur baby', 'scent free'];
  var RANGE_WORDS = ['coat', 'care', 'calm', 'paws', 'soothe', 'fresh', 'baby', 'scent',
                     'free', 'scen', 'unscented', 'scented'];
  var TYPES = ['shampoo', 'condition', 'balm', 'wipe', 'spray', 'brush', 'cloth',
               'foam', 'oil', 'towel', 'holder', 'lead', 'detangl', 'bag', 'comb'];

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function norm(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9 ]/g, ' ').replace(/ +/g, ' ').trim();
  }
  function rangeIn(text) {
    for (var i = 0; i < RANGES.length; i++) if (text.indexOf(RANGES[i]) > -1) return RANGES[i];
    if (text.indexOf('unscented') > -1 || text.indexOf('scen free') > -1) return 'scent free';
    return null;
  }
  function keyWords(text) {
    return norm(text).split(' ').filter(function (w) {
      if (w.length < 4) return false;
      if (/[0-9]/.test(w)) return false;
      if (RANGE_WORDS.indexOf(w) > -1) return false;
      return !TYPES.some(function (t) { return w.indexOf(t) > -1; });
    });
  }
  function badge(n) {
    return '<span class="paws-rcard__step paws-rcard__step--n"><b>' + n + '</b></span>';
  }
  function tidy(line) {
    return String(line || '').trim().replace(/[,;:.]+$/, '').trim();
  }
  function sizeIn(text) {
    var m = text.match(/([0-9]{2,4}) ?(ml|g)/);
    return m ? m[1] : null;
  }
  /* The spotlight line. The approved callout first, then the first sentence of
     the short description, then nothing. Never a made up line. */
  function why(p) {
    if (p.cal) return p.cal;
    if (p.sh) {
      var first = String(p.sh).split('. ')[0];
      if (first && first.length < 130) return first + '.';
    }
    return '';
  }
  /* How to use it, as one line. The directions on these products are two or
     three sentences, which on a card of nine pieces is a wall. The first
     sentence is the instruction; the rest is repetition and rinsing. The full
     text is still on the quick look and on the product page. */
  function howOne(p) {
    if (!p.dir) return '';
    var s = String(p.dir).split('. ')[0].trim();
    if (!s) return '';
    if (s.length > 110) s = s.slice(0, 107) + '...';
    if (s.charAt(s.length - 1) !== '.') s += '.';
    return s;
  }

  function build() {
    var LINES = (window.PAWS_GS_LINES || []).filter(Boolean);
    var CAT = (window.PAWS_GS_CATALOGUE || []).filter(function (p) { return p && p.h; });
    var host = document.getElementById('paws-gs-items');
    if (!host || !LINES.length || !CAT.length) return;

    var showPrices = window.PAWS_GS_SHOWPRICES === true;
    var rest = document.getElementById('paws-gs-rest');

    host.innerHTML = '';
    if (rest) { rest.hidden = true; rest.textContent = ''; }

    function byName(n) {
      var want = norm(n);
      return CAT.filter(function (p) { return norm(p.n) === want; })[0] || null;
    }
    function aliasMatch(L) {
      for (var i = 0; i < ALIASES.length; i++) {
        var a = ALIASES[i];
        if (a.needs.every(function (w) { return L.indexOf(w) > -1; })) {
          var p = a.name ? byName(a.name) : null;
          if (p) return p;
        }
      }
      return null;
    }

    function match(line) {
      var L = norm(line);

      var alias = aliasMatch(L);
      if (alias) return alias;

      var types = TYPES.filter(function (t) { return L.indexOf(t) > -1; });
      if (!types.length) return null;

      var lineKeys = keyWords(L);
      var lineRange = rangeIn(L);

      var pool = CAT.filter(function (p) {
        var N = norm(p.n);
        if (!types.some(function (t) { return N.indexOf(t) > -1; })) return false;
        if (lineRange && p.sc !== lineRange) return false;

        var prodKeys = keyWords(p.n);
        if (prodKeys.length && !prodKeys.some(function (w) { return L.indexOf(w) > -1; })) return false;
        if (lineKeys.length && !lineKeys.some(function (w) { return N.indexOf(w) > -1; })) return false;

        return true;
      });

      if (pool.length === 1) return pool[0];

      var size = sizeIn(L);
      if (size) {
        var bySize = pool.filter(function (p) { return norm(p.sz).indexOf(size) > -1; });
        if (bySize.length === 1) return bySize[0];
        if (bySize.length) pool = bySize;
      }

      var whole = pool.filter(function (p) { return L.indexOf(norm(p.n)) > -1; });
      if (whole.length === 1) return whole[0];

      return null;
    }

    var rows = LINES.map(function (line) {
      return { line: tidy(line), p: match(line) };
    });
    var matched = rows.filter(function (r) { return r.p; });

    host.innerHTML = rows.map(function (row, i) {
      var n = i + 1;
      if (!row.p) {
        return '<div class="paws-rcard paws-rcard--slim">' +
          badge(n) +
          '<div class="paws-rcard__bd">' +
            '<div class="paws-rcard__sn">Also included</div>' +
            '<div class="paws-rcard__ti">' + esc(row.line) + '</div>' +
          '</div></div>';
      }
      var p = row.p;
      var qvIndex = matched.indexOf(row);
      var w = why(p);
      var how = howOne(p);
      var media = p.img
        ? '<img src="' + esc(p.img) + '" alt="' + esc(p.n) + '" loading="lazy">'
        : '<div class="paws-slot" style="width:100%;height:100%"></div>';
      return '<div class="paws-rcard">' +
        '<a class="paws-rcard__med" href="/products/' + esc(p.h) + '">' + media + badge(n) + '</a>' +
        '<div class="paws-rcard__bd">' +
          '<div class="paws-rcard__sn">' + esc((p.sc || 'grooming').toUpperCase()) + '</div>' +
          (p.sz ? '<div class="paws-pc__sz">' + esc(p.sz) + '</div>' : '') +
          '<div class="paws-rcard__ti">' + esc(p.n) + '</div>' +
          (w ? '<p class="paws-gs__why">' + esc(w) + '</p>' : '') +
          (how ? '<p class="paws-gs__howline"><b>How to use</b> ' + esc(how) + '</p>' : '') +
          (showPrices ? '<div class="paws-rcard__pr">' + money(p.c) + ' on its own</div>' : '') +
          '<div class="paws-rcard__act">' +
            '<button type="button" class="paws-btn paws-btn--sm paws-btn--out" data-gs-qv="' + qvIndex + '">Full details</button>' +
          '</div>' +
        '</div></div>';
    }).join('');

    /* ---------- quick view ---------- */
    var pop = document.createElement('div');
    pop.className = 'paws-pop';
    pop.id = 'paws-gs-qvpop';
    pop.setAttribute('aria-hidden', 'true');
    pop.setAttribute('role', 'dialog');
    pop.innerHTML =
      '<div class="paws-popbox" style="max-width:680px;text-align:left">' +
        '<button class="paws-popbox__x" type="button" data-gs-close aria-label="Close">&times;</button>' +
        '<div class="paws-qv" id="paws-gs-qvbody"></div>' +
      '</div>';
    document.body.appendChild(pop);
    var body = pop.querySelector('#paws-gs-qvbody');

    function open(i) {
      var row = matched[i];
      if (!row || !row.p) return;
      var p = row.p;
      var media = p.img
        ? '<img src="' + esc(p.img) + '" alt="' + esc(p.n) + '">'
        : '<div class="paws-slot" style="width:100%;height:100%"></div>';
      body.innerHTML =
        '<div class="paws-qv__med">' + media + '</div>' +
        '<div>' +
          '<div class="paws-qv__sn">' + esc((p.sc || 'grooming').toUpperCase()) + (p.sz ? ' &middot; ' + esc(p.sz) : '') + '</div>' +
          '<div class="paws-display paws-d3" style="margin:8px 0 0">' + esc(p.n) + '</div>' +
          (p.ing ? '<div class="paws-ingcall" style="margin-top:12px"><span class="paws-ingcall__dot">&#10022;</span>' +
            '<span><small>Made with</small><b>' + esc(p.ing) + '</b></span></div>' : '') +
          (showPrices ? '<div class="paws-display" style="font-size:26px;margin-top:12px">' + money(p.c) + '</div>' : '') +
          (p.sh ? '<p class="paws-qv__body">' + esc(p.sh) + '</p>' : '') +
          (p.dir ? '<div class="paws-gs__how"><span class="paws-gs__howlb">How to use it</span>' +
            '<p>' + esc(p.dir) + '</p></div>' : '') +
          '<div style="display:flex;gap:10px;flex-wrap:wrap;margin-top:18px">' +
            '<a class="paws-btn" href="/products/' + esc(p.h) + '">Full details</a>' +
          '</div>' +
        '</div>';
      pop.classList.add('is-open');
      pop.setAttribute('aria-hidden', 'false');
    }
    function close() {
      pop.classList.remove('is-open');
      pop.setAttribute('aria-hidden', 'true');
    }

    host.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-gs-qv]') : null;
      if (!b) return;
      e.preventDefault();
      open(Number(b.getAttribute('data-gs-qv')));
    });
    pop.addEventListener('click', function (e) {
      if (e.target === pop || (e.target.closest && e.target.closest('[data-gs-close]'))) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();